import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api } from 'controllers/network/apiClient';

export const useShopifyPages = (): UseQueryResult<string[]> => {
  return useQuery({
    queryKey: ['shopify-pages'],
    queryFn: async (): Promise<string[]> => {
      const { pages } = await api.get(`/v2/platforms/shopify/pages`);
      return pages;
    },
  });
};
